import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import LabelledTextBox from '../../components/LabelledTextBox';
import { getHydrantManufacturer, updateHydrantManufacturer } from '../../services/api';
import { makeHydrantManufacturer } from '../../models';
import EventEmitter from '../../services/events';

const EditHydrantManufacturer = () => {
  const [hydrantManufacturer, setHydrantManufacturer] = useState(null);
  const [saving, setSaving] = useState(false);
  const { hydrantManufacturerId } = useParams();
  const history = useHistory();

  useEffect(() => {
    setupHydrantManufacturer();
  }, [hydrantManufacturerId]);

  const setupHydrantManufacturer = async () => {
    const result = await getHydrantManufacturer(hydrantManufacturerId);
    setHydrantManufacturer(makeHydrantManufacturer(result));
  };

  const save = async () => {
    try {
      setSaving(true);
      hydrantManufacturer.validate();
      await updateHydrantManufacturer(hydrantManufacturer);
      history.replace('/hydrantManufacturers');
    } catch (error) {
      console.log(error);
      if (error.name === 'ValidationError') {
        EventEmitter.emit('show-error', { title: 'Error Saving Hydrant Manufacturer', body: error.message.split('\n').map((str, idx) => <p key={idx}>{str}</p>) });
      } else {
        EventEmitter.emit('show-error', { title: 'Error Saving Hydrant Manufacturer', body: 'Unable to save hydrant manufacturer.' });
      }
    } finally {
      setSaving(false);
    }
  };

  const cancel = () => {
    history.goBack();
  };

  const onChange = e => {
    setHydrantManufacturer(makeHydrantManufacturer({ ...hydrantManufacturer, [e.target.name]: e.target.value }));
  };

  const onBlur = e => {
    const type = e.target.type;
    let value = e.target.value;
    switch (type) {
      case 'number':
        value = +value;
        break;
    }
    setHydrantManufacturer(makeHydrantManufacturer({ ...hydrantManufacturer, [e.target.name]: value }));
  };

  if (!hydrantManufacturer) return <div className="spinner"></div>;

  return (
    <div>
      <h3>Edit Hydrant Manufacturer</h3>
      {saving && <div className="spinner"></div>}
      <div className="details">
        <LabelledTextBox label="Name" value={hydrantManufacturer.name} name="name" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="Address" value={hydrantManufacturer.address} name="address" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="Address 2" value={hydrantManufacturer.address2} name="address2" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="City" value={hydrantManufacturer.city} name="city" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="State" value={hydrantManufacturer.state} name="state" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="Zip Code" value={hydrantManufacturer.zipCode} name="zipCode" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="Phone" value={hydrantManufacturer.phone} name="phone" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="Mobile Phone" value={hydrantManufacturer.mobilePhone} name="mobilePhone" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="Fax" value={hydrantManufacturer.fax} name="fax" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="Email" value={hydrantManufacturer.email} name="email" onChange={onChange} onBlur={onBlur} />
        <LabelledTextBox label="Website" value={hydrantManufacturer.website} name="website" onChange={onChange} onBlur={onBlur} />
      </div>
      <div className="form-actions">
        <button type="button" className="btn btn-secondary" onClick={cancel}>Cancel</button>
        <button type="button" className="btn btn-primary" onClick={save}>Save</button>
      </div>
    </div>
  );
};

export default EditHydrantManufacturer;
